import { render, staticRenderFns } from "./Printers.vue?vue&type=template&id=131a1ca2&scoped=true"
import script from "./Printers.vue?vue&type=script&lang=js"
export * from "./Printers.vue?vue&type=script&lang=js"
import style0 from "./Printers.vue?vue&type=style&index=0&id=131a1ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a1ca2",
  null
  
)

export default component.exports